import React from 'react';
import styled from 'styled-components';
import roboChart from '../../../assets/images/robo-img.png';

const MetricsSection = styled.div`
  margin-bottom: 24px;
`;

const MetricsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 30px;
  margin-bottom: 30px;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const MetricColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const MetricLabel = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
`;

const MetricValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #202020;
  margin-bottom: 4px;
`;

const MetricPercent = styled.div`
  font-size: 16px;
  color: #66C838;
  font-weight: 500;
`;

const MetricRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const ChartImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 20px;
  object-fit: contain;
`;

interface Metrics {
  returnSinceInception: {
    value: string;
    percent: string;
  };
  returnYesterday: {
    value: string;
    percent: string;
  };
  assetValue: string;
  profit: string;
  trackingError: string;
}

interface Props {
  metrics: Metrics;
}

const RoboadvisorMetrics: React.FC<Props> = ({ metrics }) => {
  return (
    <MetricsSection>
      <MetricsGrid>
        <MetricColumn>
          <MetricRow>
            <MetricColumn>
              <MetricLabel>Доходность с начала</MetricLabel>
              <MetricValue>{metrics.returnSinceInception.value}</MetricValue>
              <MetricPercent>{metrics.returnSinceInception.percent}</MetricPercent>
            </MetricColumn>
            <MetricColumn>
              <MetricLabel>Доходность за вчера</MetricLabel>
              <MetricValue>{metrics.returnYesterday.value}</MetricValue>
              <MetricPercent>{metrics.returnYesterday.percent}</MetricPercent>
            </MetricColumn>
          </MetricRow>
          <ChartImage src={roboChart} alt="График доходности" />
        </MetricColumn>
        <MetricColumn>
          <MetricColumn>
            <MetricLabel>Стоимость активов</MetricLabel>
            <MetricValue>{metrics.assetValue}</MetricValue>
          </MetricColumn>
          <MetricColumn>
            <MetricLabel>Профит</MetricLabel>
            <MetricValue style={{ color: '#66C838' }}>{metrics.profit}</MetricValue>
          </MetricColumn>
          <MetricColumn>
            <MetricLabel>Ошибка следования</MetricLabel>
            <MetricPercent>{metrics.trackingError}</MetricPercent>
          </MetricColumn>
        </MetricColumn>
      </MetricsGrid>
    </MetricsSection>
  );
};

export default RoboadvisorMetrics;

